/**
 * External dependencies
 */
import type {
	Account,
	Invoice,
	Maybe,
	Site,
	SubscriptionPromo,
	SubscriptionPromoId,
} from '@nab/types';

export type State = {
	readonly account: Account;

	readonly invoices: ReadonlyArray< Invoice >;
	readonly sites: ReadonlyArray< Site >;

	readonly isPageLocked: boolean;
	readonly isAgencyFullViewEnabled: boolean;

	readonly activeSubscriptionPromo: Maybe< SubscriptionPromo >;
	readonly dismissedPromos: ReadonlyArray< SubscriptionPromoId >;
};
